import React from "react";
import { default as RBS_ModalHeader, ModalHeaderProps as RBS_ModalHeaderProps } from "reactstrap/lib/ModalHeader";
import { onlyText } from "react-children-utilities";
import ModalCloseButton from "./ModalCloseButton";
import classNames from "classnames";


export type ModalHeaderProps = RBS_ModalHeaderProps & {
   lightWordsCount?: number,
   compact?: boolean,
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ children, lightWordsCount = 0, compact = false, className, toggle, cssModule, ...rest }) => {
   const splitWords = (): React.ReactNode => {
      const text = onlyText(children);
      const words = text.split(" ");
      return (<><span className="modal-title--light">{words.slice(0, lightWordsCount).join(" ")}</span>{" "}{words.slice(lightWordsCount).join(" ")}</>)
   }

   const closeBtn = toggle ? <ModalCloseButton className="close" onClick={toggle} /> : null;

   return (<RBS_ModalHeader {...rest} cssModule={compact ? { "modal-title": "modal-title-compact" } : undefined} tag="div" className={classNames({ "modal-header-compact": compact }, className)} close={closeBtn} toggle={toggle}>{lightWordsCount > 0 ? splitWords() : children}</RBS_ModalHeader>)
}

export default ModalHeader;